/* storybook-check-ignore */
import { Flex } from '@opendoor/bricks/core';

const LetterIcon = ({ size = 33 }: { size?: number }) => {
  return (
    <Flex
      width={size}
      height={size}
      minWidth={size}
      minHeight={size}
      justifyContent="center"
      alignItems="center"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="100%"
        height="100%"
        viewBox="0 0 13 15"
        fill="none"
      >
        <g opacity="0.8">
          <path
            d="M0 6.03147C0 5.40389 0.294577 4.8127 0.795602 4.43477L5.2956 1.04038C6.0085 0.50264 6.9915 0.502641 7.7044 1.04038L12.2044 4.43477C12.7054 4.8127 13 5.40389 13 6.03146V12.8477C13 13.9523 12.1046 14.8477 11 14.8477H2C0.895429 14.8477 0 13.9523 0 12.8477V6.03147Z"
            fill="#082DE6"
          />
          <path
            d="M3.34375 8.45614L5.61104 10.7229L9.65422 6.67975"
            stroke="white"
            strokeWidth="1.5"
          />
        </g>
      </svg>
    </Flex>
  );
};

export default LetterIcon;
